/**
 * This file is located here rather than shared/payloads, as webpack will prevent an import
 * of a non-Type variable outside of src.
 */
export enum TemplateId {
    Membership = "MEMBERSHIP_TEMPLATE_ID",
}
